/**
 * Created by slava on 14/8/17
 */

const BoosterHintView = function () {
    cleverapps.availableMove.on("hide", this.hide.bind(this));

    cleverapps.availableMove.on(CellHintAlgorithm.type, this.show.bind(this));
    cleverapps.availableMove.on(LineHintAlgorithm.type, this.show.bind(this));
    cleverapps.availableMove.on(ColorHintAlgorithm.type, this.show.bind(this));
};

BoosterHintView.prototype.show = function (move) {
    this.hide();

    const clicks = [
        cleverapps.boosters.getBoosterById(move.boosterId).onGetView(),
        move.target
    ].filter(Boolean);

    this.finger = FingerView.hintTap(clicks, {
        delay: move.delay / 1000,
        repeatDelay: 3
    });
};

BoosterHintView.prototype.hide = function () {
    FingerView.remove(this.finger);
    this.finger = undefined;
};
